<script>import { getCtx, getAttrs } from "../ctx.js";
export let asChild = false;
const {
  states: { checked }
} = getCtx();
$:
  attrs = {
    ...getAttrs("thumb"),
    "data-state": $checked ? "checked" : "unchecked",
    "data-checked": $checked ? "" : void 0
  };
</script>

{#if asChild}
	<slot {attrs} checked={$checked} />
{:else}
	<span {...$$restProps} {...attrs} />
{/if}
